import React from 'react';

const ScoreboxRound = ({ type, round, team1, team2 }) => {
  const teams = [
    { ...team1, ...round.teamTotals['1'] },
    { ...team2, ...round.teamTotals['2'] },
  ];
  if (!teams[0] || !teams[1]) {
    return null;
  }
  teams[0].players = [];
  teams[1].players = [];
  let currentMVP = round.mvpPoints.fcUserName + '';
  let highestPoints = 0;
  const roundWinner = parseInt(round.fnTeamWinner, 10);

  round.players.forEach((player) => {
    teams[player.fnTeam - 1].players.push(player);
  });

  const typeName = {
    KILL: "Kill",
    DEATH: "Death",
    SUB_PLAYER: "Sub",
    ADD_PLAYER: "Add",
    SWITCH_PLAYER: "Switch",
    LAGOUT: "Lagout",
    LAGIN: "Lagin",
    ELIMINATED: "Eliminated",
    ROUND_START: "Round start",
    ROUND_END: "Round end",
    FLAG_TOUCH: "Flag touch",
    OUT_OF_BOUNDS: "Out of bounds",
    // KILL_NORMAL: "Kill",
    // KILL_TK: "Kill - TK",
    // DEATH_NORMAL: "Death",
    // DEATH_TK: "Death - TK",
    // DEATH_LAGOUT: "Death - LO",
    // DEATH_DISCONNECT: "Death - DC",
    // DEATH_OOB: "Death - OOC",
    ELIMINATED_NORMAL: "Elimination",
    ELIMINATED_TK: "Elimination - TK",
    ELIMINATED_LAGOUT: "Elimination - LO",
    ELIMINATED_DISCONNECT: "Elimination - DC",
    ELIMINATED_OOB: "Elimination - OOB",
  };

  const typeID = {
    KILL: 1,
    DEATH: 2,
    SUB_PLAYER: 3,
    ADD_PLAYER: 4,
    SWITCH_PLAYER: 5,
    LAGOUT: 6,
    LAGIN: 7,
    ELIMINATED: 8,
    ROUND_START: 9,
    ROUND_END: 10,
    FLAG_TOUCH: 11,
    OUT_OF_BOUNDS: 12,
    // KILL_NORMAL: 14,
    // KILL_TK: 15,
    // DEATH_NORMAL: 16,
    // DEATH_TK: 17,
    // DEATH_LAGOUT: 18,
    // DEATH_DISCONNECT: 19,
    // DEATH_OOB: 20,
    ELIMINATED_NORMAL: 20,
    ELIMINATED_TK: 21,
    ELIMINATED_LAGOUT: 22,
    ELIMINATED_DISCONNECT: 23,
    ELIMINATED_OOB: 24,
  };

  // console.log(JSON.parse(round.events.fcEvent));
  let roundevents = [];
  let eventsstarted = 0;
  let started = false;
  let eventsraw = JSON.parse(round.events.fcEvent);

  const RoundEvent = (eventdata, eventid) => {
    const data = {
      id: eventid,
      type: eventdata[1],
      typename: null,
      time: eventdata[0] - eventsstarted,
      p1: null,
      p2: null,
      // s1: null,
      // s2: null,
      // p1x: null,
      // p1y: null,
      // p2x: null,
      // p2y: null,
      // extraPositionsInfo: null,
      // bullets: null,
      // bombs: null,
      // mines: null,
      // bursts: null,
      // repels: null,
      // dc: null,
      // eliminated: null,
      lives: null,
      // reason: null,
      // team: null,
    };

    switch (data.type) {
      // case typeID.KILL:
      // case typeID.DEATH:
      //   data.p1 = eventdata[2];
      //   data.p2 = eventdata[3];
      //   data.s1 = eventdata[4];
      //   data.s2 = eventdata[5];
      //   if (eventdata.length >= 10) {
      //     data.p1x = eventdata[6];
      //     data.p1y = eventdata[7];
      //     data.p2x = eventdata[8];
      //     data.p2y = eventdata[9];
      //     if (eventdata.length >= 15) {
      //       data.bullets = eventdata[10];
      //       data.bombs = eventdata[11];
      //       data.mines = eventdata[12];
      //       data.bursts = eventdata[13];
      //       data.repels = eventdata[14];
      //     }
      //     if (eventdata.length > 10) {
      //       data.extraPositionsInfo = [];
      //       for (let i = 15; i < eventdata.length; i++)
      //         data.extraPositionsInfo.push(eventdata[i]);
      //     }
      //   }
      //   data.eliminated = false;
      //   data.typename = typeName.DEATH;
      //   break;
      case typeID.SUB_PLAYER:
        data.p1 = eventdata[2];
        data.p2 = eventdata[3];
        data.lives = eventdata[4];
        data.typename = typeName.SUB_PLAYER;
        break;
      case typeID.ADD_PLAYER:
        data.p1 = eventdata[2];
        data.s1 = eventdata[3];
        data.typename = typeName.ADD_PLAYER;
        break;
      case typeID.SWITCH_PLAYER:
        data.p1 = eventdata[2];
        data.p2 = eventdata[3];
        data.typename = typeName.SWITCH_PLAYER;
        break;
      // case typeID.LAGOUT:
      //   data.p1 = eventdata[2];
      //   data.dc = eventdata[3];
      //   data.typename = typeName.LAGOUT;
      //   break;
      // case typeID.LAGIN:
      //   data.p1 = eventdata[2];
      //   data.typename = typeName.LAGIN;
      //   break;
      case typeID.ELIMINATED:
        data.p1 = eventdata[2];
        data.p2 = eventdata[3];
        if (eventdata.length === 5)
          data.reason = eventdata[4];
        data.typename = typeName.ELIMINATED;
        break;
      // case typeID.FLAG_TOUCH:
      //   data.team = eventdata[2];
      //   data.p1 = eventdata[3];
      //   data.typename = typeName.FLAG_TOUCH;
      //   break;
      case typeID.OUT_OF_BOUNDS:
        data.p1 = eventdata[2];
        data.typename = typeName.OUT_OF_BOUNDS;
        break;
      default:
        break;
    }
    return data;
  }

  const p = new Map();

  

  for (let e of eventsraw) {
    if (e[1] === typeID.ROUND_START) {
        eventsstarted = e[0];
        started = true;
    }

    if (e[1] !== typeID.SUB_PLAYER && e[1] !== typeID.ADD_PLAYER && e[1] !== typeID.SWITCH_PLAYER)
      continue;

    if (e[1] === typeID.ELIMINATED)
        roundevents[roundevents.length - 1].eliminated = true;

    if (started && e[1] !== typeID.KILL)
      roundevents.push(RoundEvent(e, roundevents.length));
  }

  for (let i = 0; i < teams.length; i++) {
    for (let j = 0; j < teams[i].players.length; j++) {
      p.set(teams[i].players[j].fnUserID, teams[i].players[j].fcUserName);
    }
  }

  for (let i = 0; i < roundevents.length; i++) {
    roundevents[i].n1 = p.get(roundevents[i].p1);
    roundevents[i].n2 = p.get(roundevents[i].p2);
  }

  const getTeamStats = (team) => {
    // D* Name Kills Deaths R1 R2 R3 R4 Rtg LO Note(KOs) Time
    // D* Name Kills Deaths R1 R2 R3 R4 Rtg LO Note(KOs) Time
    // D* Name Kills Deaths TK FT TeKs RPD Rtg LO Note Time
    const totals = {
      stars: 0,
      name: team.fcTeamName,
      gamescore: 0,
      kills: team.fnWins,
      deaths: team.fnLosses,
      teamkills: team.fnTeamKills,
      alive: 0,
      lagouts: team.fnLagout,
      r1: 0,
      r2: 0,
      r3: 0,
      r4: 0,
      rating: 0,
      note: '',
      time: '',
    };
    const getPlayerStats = (player) => {
      const stars =
        (type === 'twdtd'
          ? player.draft_player.fnWBStars
          : player.draft_player.fnJavStars) / 10;
      const stat = {
        stars,
        name: player.fcUserName,
        id: player.fnUserID,
        gamescore: 0,
        kills: player.fnWins,
        deaths: player.fnLosses,
        teamkills: 0,
        alive: player.fnLives - player.fnLosses > 0 ? 1 : 0,
        lagouts: player.fnLagout,
        subbed: player.fnSubstituted,
        r1: 0,
        r2: 0,
        r3: 0,
        r4: 0,
        rating: 0,
        resolution: player.fcResolution,
        note: player.fcUserNameKO ? `KO > ${player.fcUserNameKO}` : '',
        time: '',
        events: [],
      };
      if (stat.subbed === 0)
        totals.stars += stat.stars;

      for (let i = 0; i < roundevents.length; i++) {
        if (roundevents[i].p1 === stat.id) {
          // stat.events.push(roundevents[i]);
          stat.note = `O${player.fnLives} > ${roundevents[i].n2}`;
        } else if (roundevents[i].p2 === stat.id) {
          stat.note = `I${roundevents[i].lives} > ${roundevents[i].n1}`;
        }
      }

      const stats = [];
      if (type === 'twdtd') {
        player.ships.forEach((ship) => {
          const shipStats = {
            ...stat,
            gamescore: 0,
            kills: ship.fnWarbirdKill,
            deaths: ship.fnDeaths,
            rating: ship.fnRating !== -1 ? ship.fnRating : 0,
            knockouts: ship.fnKnockOuts,
            r1: ship.fnKillShortRange,
            r2: ship.fnKillNormalRange,
            r3: ship.fnKillLongRange,
            r4: ship.fnKillUltraLongRange,
          };
          shipStats.gamescore =
            shipStats.kills +
            (shipStats.kills - shipStats.deaths) +
            stat.alive +
            shipStats.knockouts;
          if (shipStats.gamescore > highestPoints || (shipStats.gamescore === highestPoints && player.fnTeam === roundWinner)) {
            highestPoints = shipStats.gamescore;
            currentMVP = player.fcUserName;
          }
          if (shipStats.note !== '') {
            let startedSplit = ship.ftTimeStarted.split(' ');
            let started = startedSplit[0] + 'T' + startedSplit[1];
            let endedSplit = ship.ftTimeEnded.split(' ');
            let ended = endedSplit[0] + 'T' + endedSplit[1];
            let timeRaw = (Date.parse(ended) - Date.parse(started)) / 1000;
            let minutes = Math.floor(timeRaw / 60);
            let seconds = timeRaw % 60;
            let time = (minutes < 10 ? '0' + minutes : minutes) + ':' + (seconds < 10 ? '0' + seconds : seconds);
            shipStats.time = time;
          }
          totals.gamescore += shipStats.gamescore;
          totals.r1 += shipStats.r1;
          totals.r2 += shipStats.r2;
          totals.r3 += shipStats.r3;
          totals.r4 += shipStats.r4;
          totals.rating += shipStats.rating;
          stats.push(shipStats);
        });
      } else if (type === 'twdtj') {
        player.ships.forEach((ship) => {
          const shipStats = {
            ...stat,
            gamescore: 0,
            kills: ship.fnJavelinKill,
            deaths: ship.fnDeaths,
            rating: ship.fnRating !== -1 ? ship.fnRating : 0,
            teamkills: ship.fnJavelinTeamKill,
            knockouts: ship.fnKnockOuts,
            r1: ship.fnKillShortRange,
            r2: ship.fnKillNormalRange,
            r3: ship.fnKillLongRange,
            r4: ship.fnKillUltraLongRange,
          };
          shipStats.gamescore =
            shipStats.kills +
            (shipStats.kills - shipStats.deaths) +
            stat.alive +
            shipStats.knockouts -
            shipStats.teamkills;
          if (shipStats.gamescore > highestPoints || (shipStats.gamescore === highestPoints && player.fnTeam === roundWinner)) {
            highestPoints = shipStats.gamescore;
            currentMVP = player.fcUserName;
          }
          if (shipStats.note !== '') {
            let startedSplit = ship.ftTimeStarted.split(' ');
            let started = startedSplit[0] + 'T' + startedSplit[1];
            let endedSplit = ship.ftTimeEnded.split(' ');
            let ended = endedSplit[0] + 'T' + endedSplit[1];
            let timeRaw = (Date.parse(ended) - Date.parse(started)) / 1000;
            let minutes = Math.floor(timeRaw / 60);
            let seconds = timeRaw % 60;
            let time = (minutes < 10 ? '0' + minutes : minutes) + ':' + (seconds < 10 ? '0' + seconds : seconds);
            shipStats.time = time;
          }
          totals.gamescore += shipStats.gamescore;
          totals.r1 += shipStats.r1;
          totals.r2 += shipStats.r2;
          totals.r3 += shipStats.r3;
          totals.r4 += shipStats.r4;
          totals.rating += shipStats.rating;
          stats.push(shipStats);
        });
      }
      let startedSplit = round.ftTimeStarted.split(' ');
      let started = startedSplit[0] + 'T' + startedSplit[1];
      let endedSplit = round.ftTimeEnded.split(' ');
      let ended = endedSplit[0] + 'T' + endedSplit[1];
      let timeRaw = (Date.parse(ended) - Date.parse(started)) / 1000;
      let minutes = Math.floor(timeRaw / 60);
      let seconds = timeRaw % 60;
      let time = (minutes < 10 ? '0' + minutes : minutes) + ':' + (seconds < 10 ? '0' + seconds : seconds);
      totals.time = time;
      return stats;
    };
    const rows = team.players.map(getPlayerStats);
    rows.unshift([totals]);
    return rows;
  };

  const getBasingTeamStats = (team) => {
    // D* Name Kills Deaths TK FT TeKs RPD Rtg LO Note Time
    const totals = {
      stars: 0,
      name: team.fcTeamName,
      ship: null,
      kills: team.fnWins,
      deaths: team.fnLosses,
      teamkills: team.fnTeamKills,
      flagtouches: 0,
      terrkills: 0,
      bombs: 0,
      mines: 0,
      repsPerDeath: [],
      bursts: 0,
      kpb: 0,
      bulletsFired: 0,
      kpbkills: 0,
      kpbtotal: 0,
      kpbships: 0,
      rating: 0,
      lagouts: team.fnLagout,
      // note: "",
    };
    const getPlayerStats = (player) => {
      const stat = {
        stars: player.draft_player.fnBaseStars / 10,
        name: player.fcUserName,
        ship: 0,
        kills: player.fnWins,
        deaths: player.fnDeaths,
        teamkills: 0,
        flagtouches: 0,
        terrkills: 0,
        repsPerDeath: 0,
        lagouts: player.fnLagout,
        subbed: player.fnSubstituted,
        rating: 0,
        resolution: player.fcResolution,
        // note: player.fcUserNameKO ? `KO > ${player.fcUserNameKO}` : "",
      };
      if (stat.subbed === 0)
        totals.stars += stat.stars;

      const stats = [];
      player.ships.forEach((ship) => {
        const kills =
          ship.fnWarbirdKill +
          ship.fnJavelinKill +
          ship.fnSpiderKill +
          ship.fnTerrierKill +
          ship.fnLancasterKill +
          ship.fnSharkKill;
        let kpb = '';
        if (
          [1, 3, 7].includes(ship.fnShipTypeID) &&
          kills > 0 &&
          ship.fnBulletsFired > 0
        ) {
          kpb = `${Math.round((kills / ship.fnBulletsFired) * 100)}%`;
        }
        let color = '';
        switch (ship.fnShipTypeID) {
          case 2:
            color = '#FB0';
            break;
          case 3:
            color = '#0B0';
            break;
          case 5:
            color = '#B00';
            break;
          case 7:
            color = '#F70';
            break;
          case 8:
            color = '#55B';
            break;
          default:
            color = '#FFF';
            break;
        }
        const shipStats = {
          ...stat,
          color,
          ship: ship.fnShipTypeID,
          kills,
          deaths: ship.fnDeaths,
          teamkills:
            ship.fnWarbirdTeamKill +
            ship.fnJavelinTeamKill +
            ship.fnSpiderTeamKill +
            ship.fnTerrierTeamKill +
            ship.fnLancasterTeamKill +
            ship.fnSharkTeamKill,
          flagtouches: ship.fnFlagClaimed,
          terrkills: ship.fnTerrierKill,
          bombs:
            ship.fnShipTypeID === 8 || ship.fnShipTypeID === 2
              ? ship.fnBombsFired
              : '',
          mines: ship.fnShipTypeID === 8 ? ship.fnMinesFired : '',
          repsPerDeath:
            ship.fnRepels > 0
              ? Math.round((ship.fnRepels / (ship.fnDeaths || 1)) * 100) / 100
              : null,
          bursts: ship.fnShipTypeID === 5 ? ship.fnBurstsFired : '',
          kpb,
          rating: ship.fnRating !== -1 ? ship.fnRating : 0,
        };
        totals.rating += shipStats.rating;
        totals.flagtouches += shipStats.flagtouches;
        totals.terrkills += shipStats.terrkills;
        totals.bombs += shipStats.bombs === '' ? 0 : shipStats.bombs;
        totals.mines += shipStats.mines === '' ? 0 : shipStats.mines;
        if (shipStats.repsPerDeath) {
          totals.repsPerDeath.push(shipStats.repsPerDeath);
        }
        totals.bursts += shipStats.bursts === '' ? 0 : shipStats.bursts;
        if (shipStats.kpb !== '') {
          totals.bulletsFired += ship.fnBulletsFired;
          totals.kpbkills += kills;
          totals.kpb = `${Math.round(
            (totals.kpbkills / totals.bulletsFired) * 100
          )}%`;
        }
        stats.push(shipStats);
      });
      return stats;
    };
    const rows = team.players.map(getPlayerStats);
    totals.repsPerDeath =
      Math.round(
        (totals.repsPerDeath.reduce((rpds, rpd) => rpds + rpd, 0) /
          (totals.repsPerDeath.length || 0)) *
          100
      ) / 100;
    if (isNaN(totals.repsPerDeath)) {
      totals.repsPerDeath = '0.00';
    }
    rows.unshift([totals]);
    return rows;
  };

  const getStats = () => {
    // D* Name Kills Deaths TK FT TeKs RPD Rtg LO Note Time
    let header;

    if (type === 'twdtd') {
      header = [
        { name: <i className="fas fa-star" />, key: 'stars' },
        { name: 'Name', key: 'name' },
        { name: 'K', key: 'kills' },
        { name: 'D', key: 'deaths' },
        { name: 'R1', key: 'r1' },
        { name: 'R2', key: 'r2' },
        { name: 'R3', key: 'r3' },
        { name: 'R4', key: 'r4' },
        { name: 'GS', key: 'gamescore' },
        // { name: 'Rtg', key: 'rating' },
        { name: 'LO', key: 'lagouts' },
        { name: 'RES', key: 'resolution' },
        { name: 'Note', key: 'note' },
        { name: 'TP', key: 'time' },
      ];
    } else if (type === 'twdtj') {
      header = [
        { name: <i className="fas fa-star" />, key: 'stars' },
        { name: 'Name', key: 'name' },
        { name: 'K', key: 'kills' },
        { name: 'D', key: 'deaths' },
        { name: 'R1', key: 'r1' },
        { name: 'R2', key: 'r2' },
        { name: 'R3', key: 'r3' },
        { name: 'R4', key: 'r4' },
        { name: 'TKs', key: 'teamkills' },
        { name: 'GS', key: 'gamescore' },
        // { name: 'Rtg', key: 'rating' },
        { name: 'LO', key: 'lagouts' },
        { name: 'RES', key: 'resolution' },
        { name: 'Note', key: 'note' },
        { name: '', key: 'time' },
      ];
    } else if (type === 'twdtb') {
      header = [
        { name: <i className="fas fa-star" />, key: 'stars' },
        { name: 'Name', key: 'name' },
        { name: 'Ship', key: 'ship' },
        { name: 'K', key: 'kills' },
        { name: 'D', key: 'deaths' },
        { name: 'TKs', key: 'teamkills' },
        { name: 'FT', key: 'flagtouches' },
        { name: 'TeKs', key: 'terrkills' },
        { name: 'BOMBs', key: 'bombs' },
        { name: 'Mines', key: 'mines' },
        { name: 'RPD', key: 'repsPerDeath' },
        { name: 'BURs', key: 'bursts' },
        { name: 'K/BUL', key: 'kpb' },
        { name: 'Rtg', key: 'rating' },
        { name: 'LO', key: 'lagouts' },
        { name: 'RES', key: 'resolution' },
      ];
    }

    const getTeamStatsFn = type === 'twdtb' ? getBasingTeamStats : getTeamStats;
    const team1stats = getTeamStatsFn(teams[0]);
    const team2stats = getTeamStatsFn(teams[1]);

    return {
      header,
      team1: {
        totals: team1stats.shift(),
        ships: team1stats,
      },
      team2: {
        totals: team2stats.shift(),
        ships: team2stats,
      },
    };
  };

  const stats = getStats();

  const printStats = (statsArr, totals = false) =>
    statsArr.map((ship) => (
      <tr
        className={`scorebox-table--row ${totals ? 'totals' : (ship.name === currentMVP ? 'mvp' : '')}`}
        key={Math.random()}>
        {stats.header.map(({ key }) => (
          <td
            className={`scorebox-table--row--stat ${key}`}
            key={Math.random()}
            style={{ color: key === 'name' ? ship.color : 'inherit' }}>
            {ship[key]}
          </td>
        ))}
      </tr>
    ));

  return (
    <div className="scorebox-table">
      <table>
        <thead>
          <tr className="scorebox-table--header">
            {stats.header.map((head) => (
              <th
                className={`scorebox-table--header--stat ${head.key}`}
                key={head.key}>
                {head.name}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {printStats(stats.team1.totals, true)}
          {stats.team1.ships.map((ts) => printStats(ts, false))}
          {printStats(stats.team2.totals, true)}
          {stats.team2.ships.map((ts) => printStats(ts, false))}
        </tbody>
      </table>
    </div>
  );
};

export default ScoreboxRound;



// WEBPACK FOOTER //
// ./src/components/scorebox-round/scorebox-round.js